import { Alert, Box, Button, Container, TextField, Typography } from "@mui/material";
import { useState } from "react";
import { Link, useSearchParams } from "react-router-dom";

export default function ResetPassword() {
    const [searchParams] = useSearchParams();
    const [password, setPassword] = useState("");
    const [password2, setPassword2] = useState("");
    const [error, setError] = useState("");
    const [success, setSuccess] = useState("");

    const token = searchParams.get("token") || "";

    const onSubmit = async (event) => {
        event.preventDefault();
        setError("");
        setSuccess("");

        if (!token) {
            setError("Reset-Token fehlt.");
            return;
        }
        if (!password || !password2) {
            setError("Bitte beide Passwort-Felder ausfüllen.");
            return;
        }
        if (password !== password2) {
            setError("Passwörter stimmen nicht überein.");
            return;
        }

        try {
            const response = await fetch(`${process.env.REACT_APP_API_URI}/api/auth/password/reset`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify({
                    token,
                    newPassword: password,
                }),
            });
            const data = await response.json();
            if (!response.ok) {
                throw new Error(data?.message || "Passwort konnte nicht zurückgesetzt werden.");
            }
            setSuccess("Passwort wurde erfolgreich geändert. Bitte jetzt einloggen.");
            setPassword("");
            setPassword2("");
        } catch (submitError) {
            setError(submitError.message);
        }
    };

    return (
        <Container maxWidth="xs" sx={{ mt: 12 }}>
            <Typography variant="h5" component="h1" gutterBottom textAlign="center">
                Passwort zurücksetzen
            </Typography>
            {error && <Alert severity="error" sx={{ my: 2 }}>{error}</Alert>}
            {success && <Alert severity="success" sx={{ my: 2 }}>{success}</Alert>}
            <Box component="form" onSubmit={onSubmit}>
                <TextField
                    label="Neues Passwort"
                    variant="outlined"
                    type="password"
                    autoComplete="new-password"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    sx={{ mt: 1 }}
                    fullWidth
                />
                <TextField
                    label="Neues Passwort (wiederholen)"
                    variant="outlined"
                    type="password"
                    autoComplete="new-password"
                    value={password2}
                    onChange={(e) => setPassword2(e.target.value)}
                    sx={{ mt: 3 }}
                    fullWidth
                />
                <Button variant="contained" type="submit" sx={{ mt: 3 }} fullWidth>
                    Passwort speichern
                </Button>
            </Box>
            <Box sx={{ mt: 2, textAlign: "center" }}>
                <Link to="/login">Zurück zum Login</Link>
            </Box>
        </Container>
    );
}
